
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CreateInsuranceTypeCoverageCategoryDto } from '../../../../core/data/new-dtos/insurance-type.dtos';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@Component({
    selector: 'app-coverage-rate-selector',
    standalone: true,
    imports: [CommonModule, FormsModule, NgxMaskDirective],
    templateUrl: './coverage-rate-selector.component.html',
    styles: [`
    .card-header input {
        background: transparent;
    }
    .card-header input:focus {
        background: white;
    }
  `],
    providers: [provideNgxMask()]
})
export class CoverageRateSelectorComponent {
    @Input() categories: CreateInsuranceTypeCoverageCategoryDto[] = [];
    @Input() maxAge: number = 100;
    @Output() categoriesChange = new EventEmitter<CreateInsuranceTypeCoverageCategoryDto[]>();

    categoryOptions = [
        { value: '1', label: 'Riesgo 1' },
        { value: '2', label: 'Riesgo 2' },
        { value: '3', label: 'Riesgo 3' }
    ];

    addCategory() {
        if (this.categories.length >= 3) return;

        this.categories.push({
            category: '',
            rates: []
        });
        this.emitChange();
    }

    removeCategory(index: number) {
        this.categories.splice(index, 1);
        this.emitChange();
    }

    addRate(categoryIndex: number) {
        this.categories[categoryIndex].rates.push({
            ageFrom: 0,
            ageTo: this.maxAge,
            rate: 0
        });
        this.emitChange();
    }

    removeRate(categoryIndex: number, rateIndex: number) {
        this.categories[categoryIndex].rates.splice(rateIndex, 1);
        this.emitChange();
    }

    emitChange() {
        this.categoriesChange.emit(this.categories);
    }
}
